// src/utils/uploadService.ts
import api from "../../../../features/auth/axiosConfig";

export const uploadFile = async (
  file: File,
  endpoint: string,
  method: "post" | "put" = "post",
  filename?: string
) => {
  const formData = new FormData();
  formData.append("file", file);

  const url = filename ? `${endpoint}?filename=${filename}` : endpoint;

  return method === "put"
    ? api.put(url, formData, { headers: { "Content-Type": "multipart/form-data" } })
    : api.post(url, formData, { headers: { "Content-Type": "multipart/form-data" } });
};
